/** @format */

import { Component, Input, OnInit } from '@angular/core';

import { Cta } from '@category/data-access';
import { IFullStoryV2 } from './full-story-v2.interface';
import { TaggingService } from '@shared/data-access/services';

@Component({
	selector: 'clp-mw-full-story-w-moving-copy-box',
	templateUrl: './full-story-w-moving-copy-box.component.html',
	styleUrl: './full-story-w-moving-copy-box.component.scss',
	standalone: false
})
export class FullStoryWMovingCopyBoxComponent implements OnInit {
	story: IFullStoryV2;
	altTagService: any;

	@Input() data: IFullStoryV2[];
	@Input() tagSectionNum: string;
	@Input() pageType: string;
	@Input() widgetTypeTag = 'story';

	constructor(private taggingService: TaggingService) {
		this.altTagService = taggingService.altTag;
	}

	ngOnInit() {
		if (this.data) {
			this.story = this.data[0];
		}
	}

	createTag(itemIndex: number, ctaIndex: number, ctaText: string, altText: string) {
		return this.taggingService.createTag(
			this.tagSectionNum,
			this.widgetTypeTag,
			itemIndex,
			ctaIndex,
			ctaText,
			altText
		);
	}

	trackByCta(index: number, item: Cta): string {
		return index.toString() + item.link;
	}
}
